import React from 'react';
import PageTemplate from 'components/common/PageTemplate';
import Order from 'view/order';

const OrderPage = () => {
	return (
		<PageTemplate>
			<Order />
		</PageTemplate>
	);
};

export default OrderPage;

 